import {getIndexNavList,getIndexNavTree,getValidDictionaryList,getPlatformList,getIndexNav,saveIndexNav,deleteIndexNav,getBuildPageTree,getBuildPageList,getbuildpage} from '@/api/api'

const state={
    indexNavTabList:[],
    indexSectionList:[],
    indexPlatformList:[],
    indexModuleTabList:[],
    indexModuleList:[],
};
const getters = {
    getIndexNavTabList:function(state){
        return state.indexNavTabList
    },
    getIndexSectionList:function(state){
        return state.indexSectionList
    },
    getIndexModuleTabList:function(state){
        return state.indexModuleTabList
    },
    getIndexModuleList:function(state){
        return state.indexModuleList
    }
};
const actions = {
    initIndexNavTabList({commit,state},param){
        return new Promise((resolve) => {
            getIndexNavTree(param).then((res) => {
                if(res.data.status == 200){
                    commit('INIT_INDEX_NAV_TABLIST',res.data.value[0].children);
                    resolve(res.data.value[0])
                }
            })
        })

    },
    initIndexSectionList({commit,state},param){
        getIndexNavList(param).then((res) => {
            if(res.data.status == 200){
                commit('INIT_INDEX_SECTION_LIST',res.data.value);
            }
        })
    },
    initIndexBuildMoList({commit,state},param){
        return new Promise((resolve) => {
            getBuildPageList(param).then((res) => {
                resolve(res)
            })
        })
    },
    initIndexModuleTabList({commit,state},param){
        return new Promise((resolve) => {
            getBuildPageTree(param).then((res) => {
                if(res.data.status == 200){
                    commit('INIT_INDEX_MODULE_TABLIST',res.data.value[0].children);
                    resolve(res.data.value[0])
                }
            })
        })

    },
    initIndexModuleList({commit,state},param){
        return new Promise((resolve) => {
            getBuildPageList(param).then((res) => {
                if(res.data.status == 200){
                    commit('INIT_INDEX_MODULE_LIST',res.data.value);
                    resolve(res.data.value)
                }
            })
        })
    },
    initIndexBuildPageDetail({commit,state},param){
        return new Promise((resolve) => {
            getbuildpage(param).then((res) => {
                if(res.data){
                    resolve(res.data)
                }
            })
        })

    },
};
const mutations = {
    INIT_INDEX_NAV_TABLIST(state,param){
        state.indexNavTabList = param
    },
    INIT_INDEX_SECTION_LIST(state,param){
        state.indexSectionList = param
    },
    INIT_INDEX_MODULE_TABLIST(state,param){
        state.indexModuleTabList = param
    },
    INIT_INDEX_MODULE_LIST(state,param){
        state.indexModuleList = param
    }
};
export default {
    state,
    getters,
    actions,
    mutations,
}


// WEBPACK FOOTER //
// ./src/store/modules/indexNavTabList.js